import type React from 'react';
import type { JSX } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsBasketball = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox="0 0 20 20">
        <path
            d="M1.7085 9.14587C1.77794 8.43754 1.92377 7.7674 2.146 7.13546C2.36822 6.50351 2.67377 5.90976 3.06266 5.35421C3.54877 5.85421 3.95502 6.43407 4.28141 7.09379C4.6078 7.75351 4.81961 8.43754 4.91683 9.14587H1.7085ZM15.0835 9.14587C15.1807 8.43754 15.3891 7.75698 15.7085 7.10421C16.0279 6.45143 16.4377 5.87504 16.9377 5.37504C17.3266 5.91671 17.6321 6.50699 17.8543 7.14587C18.0766 7.78476 18.2224 8.45143 18.2918 9.14587H15.0835ZM3.06266 14.625C2.67377 14.0834 2.36822 13.4966 2.146 12.8646C1.92377 12.2327 1.77794 11.5625 1.7085 10.8542H4.91683C4.81961 11.5625 4.6078 12.2431 4.28141 12.8959C3.95502 13.5487 3.54877 14.125 3.06266 14.625ZM16.9377 14.625C16.4377 14.125 16.0279 13.5487 15.7085 12.8959C15.3891 12.2431 15.1807 11.5625 15.0835 10.8542H18.2918C18.2224 11.5487 18.0766 12.2153 17.8543 12.8542C17.6321 13.4931 17.3266 14.0834 16.9377 14.625ZM6.60433 9.14587C6.49322 8.14587 6.22238 7.22226 5.79183 6.37504C5.36127 5.52782 4.79877 4.76393 4.10433 4.08337C4.771 3.41671 5.53141 2.88199 6.38558 2.47921C7.23975 2.07643 8.15989 1.81949 9.146 1.70837V9.14587H6.60433ZM10.8543 9.14587V1.70837C11.8404 1.81949 12.7606 2.07643 13.6147 2.47921C14.4689 2.88199 15.2293 3.41671 15.896 4.08337C15.1877 4.75004 14.6217 5.51046 14.1981 6.36462C13.7745 7.21879 13.5071 8.14587 13.396 9.14587H10.8543ZM9.146 18.2917C8.146 18.1806 7.22238 17.9202 6.37516 17.5105C5.52794 17.1007 4.771 16.5625 4.10433 15.8959C4.81266 15.2292 5.37863 14.4723 5.80225 13.625C6.22586 12.7778 6.49322 11.8542 6.60433 10.8542H9.146V18.2917ZM10.8543 18.2917V10.8542H13.396C13.5071 11.8542 13.7745 12.7813 14.1981 13.6355C14.6217 14.4896 15.1877 15.25 15.896 15.9167C15.2293 16.5834 14.4689 17.1181 13.6147 17.5209C12.7606 17.9237 11.8404 18.1806 10.8543 18.2917Z"
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
